import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, ipAddress, userLocation, userName} from '../../Univ.js'
const IpDrugUse = (props) => {
    const {pat_id} = useParams();
    const {ip_id} = useParams();
    const [patientData, setPatientData] = useState([]);
    const [drugData, setDrugData] = useState([]);
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [isChecked, setIsChecked] = useState(false);
    const [tickQty, setTickQty] = useState({});
    const [pharmData, setPharmData] = useState({
        "ip": '',
        "pat": '',
        "drug_id": '',
        "qty": '',
        "drug_status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseUrl}pat-id/${pat_id}/`);
                if (response.status === 200 || response.status === 201) {
                    setPatientData(response.data);
                } else {
                    window.location.href = '/pat-search/';
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        fetchDrugData();
    }, []);
    const fetchDrugData = () => {
            axios.get(baseUrl + "view-use-drug-ip/" + ip_id + "/")
                .then(response => {
                    setDrugData(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    ;
    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };
    const handleCheckboxChange = async (index, drugId) => {
        // Update the state to mark the checkbox as checked
        const updatedDrugData = [...drugData];
        updatedDrugData[index].isChecked = true;
        setDrugData(updatedDrugData);
        const currentQty = tickQty[index] || 0;
        const updatedQty = currentQty + 1;
        setTickQty({...tickQty, [index]: updatedQty});
        const newDrugTime = document.getElementById("drug_time").value;
        updatedDrugData[index].drug_time = updatedDrugData[index].drug_time ? `${updatedDrugData[index].drug_time},${newDrugTime}` : newDrugTime;
        setDrugData(updatedDrugData);
        // Prepare the form data
        const formData = new FormData();
        formData.append('use_status', '2');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        formData.append('tick_qty', updatedQty);
        formData.append('drug_time', updatedDrugData[index].drug_time);
        // Submit the form
        axios
            .post(`${baseUrl}update-use-drug/` + drugId + '/', formData)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    // Reset the form
                    setSelectedDateTime(new Date());
                    // Show success message
                    Swal.fire({
                        title: 'Success!',
                        text: 'Drug request submitted successfully.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                    const updatedRow = {...updatedDrugData[index]};
                    updatedDrugData[index] = updatedRow;
                    setDrugData(updatedDrugData);
                }
            })
            .catch((error) => {
                console.log(error);
                // Show error message
                Swal.fire({
                    title: 'Error!',
                    text: 'Failed to submit drug request. Please try again later.',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false,
                });
            });
    };
    useEffect(() => {
        // Initialize tickQty with tick_qty values from the row objects
        const initialTickQty = {};
        drugData.forEach((row, index) => {
            initialTickQty[index] = parseInt(row.tick_qty) || 0;
        });
        setTickQty(initialTickQty);
    }, [drugData]);
    return (
        <section className="container mt-4">

            <div className="row table-responsive">
                <div className='col-md-12 col-12 mb-2'>
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th>Patient ID</th>
                            <th>Patient Name</th>
                            <th>Gender</th>
                            <th>D.O.B/Age</th>
                            <th>Marital Status</th>
                            <th>Regd. On</th>
                            <th>Occupation</th>
                        </tr>
                        </thead>

                        <tbody>
                        {patientData.map((patientData, index) => (
                            <tr key={index}>
                                <td>{patientData.pat_id}</td>
                                <td>{patientData.patient}</td>
                                <td>{patientData.gender}</td>
                                <td>{patientData.age}</td>
                                <td>{patientData.marital_status}</td>
                                <td>{patientData.add_date}</td>
                                <td>{patientData.occupation}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row mt-4">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    Medicine Request View</h3>
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Date</th>
                        <th>Drug ID</th>
                        <th>Drug Name</th>
                        <th>Dose</th>
                        <th>Addedby</th>
                        <th>Given Time</th>
                        <th>Drug Time</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {Array.isArray(drugData) && drugData.map((row, index) => (
                        <tr key={row.id}>
                            <td>{row.add_date}</td>
                            <td>{row.drug.id}</td>
                            <td>{row.drug.product.product}</td>
                            <td>{row.qty}</td>
                            <td>{row.addedby}</td>
                            <td>{row.add_time?.split('.')[0]}</td>
                            <td>
                                <DatePicker
                                    className="form-control"
                                    selected={selectedDateTime}
                                    name="drug_time"
                                    id="drug_time"
                                    onChange={handleDateTimeChange}
                                    dateFormat="yyyy-MM-dd h:mm"
                                    showTimeSelect
                                    timeIntervals={15}
                                    timeCaption="Time"
                                />
                            </td>
                            <td>
                                {Array.from({length: row.qty}, (_, i) => (
                                    <input
                                        key={i}
                                        type="checkbox"
                                        checked={i < (tickQty[index] || 0)}
                                        onChange={() => handleCheckboxChange(index, row.id)}
                                        disabled={i < tickQty[index]}
                                    />
                                ))}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>

            </div>


        </section>
    );
};
export default IpDrugUse;
